import { RolePermissionObjects } from './rolePermissionObjects.constants';

export const usersRouteConfig = [
    { routerLink: '/dashboard/users/management', title: 'Users', objectId: RolePermissionObjects.User },
    { routerLink: '/dashboard/users/roles', title: 'Roles', objectId: RolePermissionObjects.RolePermission },
    { routerLink: '/dashboard/users/organizations', title: 'Organizations' }
]